import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import SearchOffOutlinedIcon from "@mui/icons-material/SearchOffOutlined";
import ServiceProviderCard from "../ServiceProviderCard";
import { useParams } from "react-router-dom";
import LoadingAnimation from "../../Animations/LoadingAnimation";
import { fonts, headingFonts, notFoundBox } from "../../../Styles/Styles";

export default function ServiceProviderList() {
  const { serviceId } = useParams();
  console.log(serviceId);
  const [providers, setProviders] = useState(null);
  const [service, setService] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Fetch subservice details from API
    const fetchProviders = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_SERVER_BASE_URL}/services/serviceProviders/${serviceId}`
        );
        const data = await response.json();
        setProviders(data.serviceProviders);
        setService(data.service);
        console.log(data);
      } catch (error) {
        console.error("Failed to fetch subservice details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProviders();
  }, [serviceId]);

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "200px",
        }}
      >
        <LoadingAnimation />
      </Box>
    );
  }

  if (!providers) {
    return (
      <Box mt={3} sx={{ ...notFoundBox }}>
        <SearchOffOutlinedIcon
          sx={{
            color: "var(--primary-color)",
            fontSize: 50,
            opacity: 0.5,
            marginBottom: 1,
          }}
        />
        <Typography
          variant="h6"
          sx={{
            color: "var(--primary-color)",
            ...headingFonts,
          }}
        >
          Oops! Service Providers Not Found
        </Typography>
        <Typography variant="body2" sx={{ opacity: 0.7, ...fonts }}>
          We couldn't find any service providers at the moment. Please try again
          later.
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      <Box mt={2} mb={2}>
        <Typography gutterBottom variant="h5" sx={{ ...headingFonts }}>
          Choose a Service Provider:
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ ...fonts }}>
          Browse through our list of trusted providers to find the perfect
          service for your needs.
        </Typography>
      </Box>
      {providers.map((provider, index) => (
        <ServiceProviderCard key={index} provider={provider} />
      ))}
    </Box>
  );
}
